import { Link } from "react-router-dom";
import Ornament from "@/components/Ornament";
import Footer from "@/components/Footer";
import LanguageDropdown from "@/components/LanguageDropdown";
import { RR_LOGO, VENUE_BG } from "@/lib/constants";
import { useLang, t } from "@/lib/i18n";

const quickLinks = [
  { slug: "caffetteria", label: "Caffetteria" },
  { slug: "granite", label: "Granite" },
  { slug: "pasticceria", label: "Pasticceria" },
  { slug: "cocktail-pre-dinner", label: "Cocktail" },
];

export default function Home() {
  const lang = useLang();
  return (
    <div data-testid="home-page" className="min-h-screen flex flex-col texture-grain">
      <div className="relative flex-1 flex flex-col">
        <img
          src={VENUE_BG}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[#FAF7F2]/70" />
        <div className="absolute top-4 right-4 z-30">
          <LanguageDropdown />
        </div>
        <div className="relative flex-1 flex flex-col items-center justify-center text-center px-6 py-12">
          <img
            data-testid="rr-logo"
            src={RR_LOGO}
            alt="Logo Ritrovo Rinascente"
            className="h-36 sm:h-44 w-auto animate-fade-up drop-shadow-[0_12px_28px_rgba(28,27,26,0.28)]"
          />
          <h1
            data-testid="home-title"
            className="font-display italic font-semibold text-4xl sm:text-5xl lg:text-6xl text-[var(--bordeaux)] mt-7 animate-fade-up"
            style={{ animationDelay: "0.12s" }}
          >
            Ritrovo Rinascente
          </h1>
          <div className="animate-fade-up" style={{ animationDelay: "0.2s" }}>
            <Ornament />
          </div>
          <p
            className="font-cinzel text-xs sm:text-sm tracking-[0.3em] uppercase text-[var(--bordeaux-2)] animate-fade-up"
            style={{ animationDelay: "0.26s" }}
          >
            {t(lang, "subtitle")}
          </p>
          <p
            className="font-display italic text-lg sm:text-xl text-[var(--text-2)] mt-5 max-w-md leading-relaxed animate-fade-up"
            style={{ animationDelay: "0.34s" }}
          >
            {t(lang, "tagline")}
          </p>
          <p className="text-xs text-[var(--muted)] mt-3 tracking-wide animate-fade-up" style={{ animationDelay: "0.4s" }}>
            Via dei Mille, 240/242 — Messina
          </p>
          <Link
            data-testid="cta-consulta-menu"
            to="/menu"
            className="mt-9 inline-flex items-center gap-2 bg-gradient-to-br from-[#7A1C2E] to-[#54101A] text-[#EED8A1] font-cinzel text-sm tracking-[0.2em] uppercase px-9 py-4 rounded-full border border-[#C5A059]/60 shadow-[0_10px_35px_rgba(84,16,26,0.55)] hover:shadow-[0_14px_45px_rgba(84,16,26,0.7)] hover:-translate-y-0.5 transition-all duration-300 animate-fade-up"
            style={{ animationDelay: "0.48s" }}
          >
            {t(lang, "consultMenu")}
          </Link>
          <div className="mt-7 flex flex-wrap justify-center gap-2 animate-fade-up" style={{ animationDelay: "0.56s" }}>
            {quickLinks.map((q) => (
              <Link
                key={q.slug}
                data-testid={`quick-link-${q.slug}`}
                to={`/menu/${q.slug}`}
                className="text-[11px] font-cinzel tracking-widest uppercase text-[var(--text-2)] border border-[#C5A059]/45 rounded-full px-4 py-2 hover:border-[#C5A059] hover:text-[var(--bordeaux)] transition-colors duration-300"
              >
                {q.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
